// React
import React, { FunctionComponent, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { StatusBarStyled } from '../../../../components/component-items/status-bar'

import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTheme } from 'styled-components'

// Components
import { ProgressList } from '../../../warehouse/packing/styles'
import GlobalStyles from '../../../../components/component-items/styles'
import { notify } from '../../../../components/component-items/helpers'

// Modals
import { ReceivingFeesModal } from '../receiving-fees-modal'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBarcodeRead, faFileInvoiceDollar, faExclamationTriangle } from '@fortawesome/pro-duotone-svg-icons'

import { MenuOptionProps, ReceivingReviewWorkflowProps } from './types'

const MenuOption: FunctionComponent<MenuOptionProps> = ({ url, icon, title, active, enabled, onClick, options }) => {
  return (
    <li onClick={onClick} className={active ? 'active' : !enabled ? 'disabled' : ''}>
      {options ? (
        <Row style={{ padding: '.6em' }}>
          {Object.keys(options).map((key, index) => (
            <Col key={index} lg={6}>
              <GlobalStyles.Button
                className="secondary"
                onClick={options[key]}
                style={{ width: '100%', height: 35, margin: '0' }}
                disabled={!active}
              >
                {key}
              </GlobalStyles.Button>
            </Col>
          ))}
        </Row>
      ) : (
        <Link to={url && enabled ? url : '#'}>
          <span className="icon">
            <FontAwesomeIcon icon={icon} />
          </span>
          <span className="text">{title}</span>
        </Link>
      )}
    </li>
  )
}

export const ReceivingReviewWorkflow: FunctionComponent<ReceivingReviewWorkflowProps> = ({
  asn,
  current,
  itemId,
  itemComplianceCompleted,
  asnComplianceCompleted,
  asnCompliance,
}) => {
  const theme: any = useTheme()
  const url = `/asn/${asn}/`
  const navigate = useNavigate()
  const [openCompliance, setCompliance] = useState(false)

  const handleNextItem = () => {
    navigate(url + 'receive/')
  }

  const handleComplete = async () => {
    if (asnComplianceCompleted) {
      navigate('#review')
      setCompliance(true)
    } else {
      notify({
        type: 'warning',
        message: 'Set a compliance status for each item. Add a receiving fee for any item marked non-compliant.',
      })
    }
  }

  const options: any = {
    'Next Item': handleNextItem,
    Review: handleComplete,
  }

  return (
    <>
      <ProgressList>
        <ul>
          <MenuOption
            url={url + 'receive/'}
            active={current === 'scan_item'}
            enabled
            icon={faBarcodeRead}
            title={'Select Product'}
          />

          <MenuOption
            url={url + `item/${itemId}/receiving-review/`}
            active={current === 'receiving_review'}
            icon={faFileInvoiceDollar}
            enabled={current === 'receiving_review'}
            title={'Receiving Review'}
          />

          {/* Completion requires a compliance status and receiving fees for non-compliant items. */}
          <MenuOption
            enabled={itemComplianceCompleted || asnComplianceCompleted}
            active={itemComplianceCompleted || asnComplianceCompleted}
            options={options}
          />
        </ul>
      </ProgressList>

      {current === 'receiving_review' && !itemComplianceCompleted && (
        <StatusBarStyled style={{ backgroundColor: 'white' }}>
          <div className="header-item">
            <div className="status-icon">
              <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: theme.colors.mySin }} />
            </div>
            <div className="status-text">Compliance is incomplete for this item</div>
          </div>
        </StatusBarStyled>
      )}
      <ReceivingFeesModal {...asnCompliance} open={openCompliance} setOpen={setCompliance} />
    </>
  )
}
